import { useState } from 'react';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import { UnitPcvFinantial, UnitPcvFinantialForm } from '../models/unitPcv';
import useCallApiAndLoad from '../../../hooks/useCallApiAndLoad';

const unitPcvFinantialSchema = yup
  .object({
    initial_reserve: yup
      .number()
      .min(0, 'La reserva inicial debe ser mayor o igual a cero.')
      .required('La reserva inicial es requerida.'),
    initial_down_payment: yup
      .number()
      .min(0, 'La prima inicial debe ser mayor o igual a cero.')
      .required('La prima inicial es requerida.'),
    down_payment_paid: yup
      .number()
      .min(0, 'La prima pagada debe ser mayor o igual a cero.')
      .required('La prima pagada es requerida.'),
    percentage_down_payment: yup
      .number()
      .min(0, 'El porcentaje debe ser mayor o igual a cero.')
      .max(100, 'El porcentaje no puede ser mayor a 100.')
      .required('El porcentaje de prima es requerido.'),
    current_reserve: yup
      .number()
      .min(0, 'La reserva actual debe ser mayor o igual a cero.')
      .required('La reserva actual es requerida.'),
    quotas_down_payment: yup
      .number()
      .transform((value) => (isNaN(value) ? 0 : value))
      .nullable()
      .default(0),
    quotas_down_payment_paids: yup
      .number()
      .transform((value) => (isNaN(value) ? 0 : value))
      .nullable()
      .default(0),
  })
  .required();

const useManageUnitPcvFinantialForm = (finantial?: UnitPcvFinantial) => {
  const { isLoading } = useCallApiAndLoad();
  const [error, setError] = useState<string | null>(null);

  const {
    handleSubmit,
    formState: { errors },
    control,
  } = useForm<UnitPcvFinantialForm>({
    resolver: yupResolver(unitPcvFinantialSchema),
  });

  return {
    handleSubmit,
    errors,
    control,
    isLoading,
    error,
    setError,
    isEditing: !!finantial,
    finantial,
  };
};

export default useManageUnitPcvFinantialForm;
